module.exports = __webpack_public_path__ + "media/images/top/topics-sp-banner-c7860aa85d695745fae9824c35a82b69.webp";